module.exports = __webpack_public_path__ + "img/9.c1c2aa09.png";